import axios from 'axios';

import { IStall, Stall, StallCriteria } from '@/shared/model/stall.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/stalls';

export default class StallService {
  public setActive(id: number, active: boolean) {
    axios.post(`${baseApiUrl}Active/${id}/${active}`);
  }

  public find(id: number): Promise<IStall> {
    return new Promise<IStall>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(req?: any, criteria?: StallCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}Filter?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public retrieveAll(): Promise<any> {
    return axios.get(`${baseApiUrl}`);
  }

  public retrieveAllSorted(): Promise<any> {
    return axios.get(`${baseApiUrl}FilterNP`);
  }

  public retrieveAllActiveSorted(): Promise<any> {
    return axios.get(`${baseApiUrl}FilterNPActive`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IStall): Promise<IStall> {
    return new Promise<IStall>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IStall): Promise<IStall> {
    return new Promise<IStall>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
